import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

const IMPLEMENTED_REPORTS = ['leads', 'deals', 'contacts', 'tickets', 'campaigns', 'marketing-analytics'];

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit, OnDestroy {
  selectedReport: string = '';
  private destroy$ = new Subject<void>();

  constructor(
    private localStorage: LocalStorageService,
    private route: ActivatedRoute,
  ) {}

  accessObject: any = {};

  ngOnInit() {
    this.accessObject = this.localStorage.checkCRUDAccess('report', 'Reports');

    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      const type = params['type'];
      if (type) {
        this.applyReport(type);
        return;
      }

      const storedReport = localStorage.getItem('selectedReport');
      this.applyReport(storedReport || 'leads');
    });
  }

  get isImplementedReport(): boolean {
    return IMPLEMENTED_REPORTS.includes(this.selectedReport);
  }

  get selectedReportLabel(): string {
    return (this.selectedReport || 'report')
      .split('-')
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ');
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private applyReport(report: string): void {
    this.selectedReport = report;
    localStorage.setItem('selectedReport', report);
  }
}
